module.exports = __webpack_public_path__ + "static/media/profile.c710235a.jpeg";